import React, { useEffect, useState } from "react";
import "./Orders.css";
import axios from "axios";
import {UilSearch} from "@iconscout/react-unicons"
import { filterCardsData } from "../../Data/Data";
import FilterCard from "../../Components/FilterCard/FilterCard";
import DatePicker from "../../Components/DatePicker/DatePicker";
import OrdersTable from "../../Components/OrdersTable/OrdersTable";
import { useSelector } from "react-redux";
import { markShortfallOrdersSeen } from "../../utils/shortfallOrdersSeen";


// No module-level interceptor  token is synced inside the component via
// useEffect, after Redux-Persist has rehydrated currentUser from localStorage.
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:4000/api",
  timeout: 60000,
});

const Orders = () => {

const [orders, setOrders] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);

const { currentUser } = useSelector((state) => state.auth);

// currentUser shape: { message, worker: {...}, token: "Bearer eyJ...", refreshToken: "eyJ..." }
useEffect(() => {
  const rawToken     = currentUser?.token || null;
  const refreshToken = currentUser?.refreshToken || null;

  if (rawToken) {
    const token = rawToken.startsWith("Bearer ") ? rawToken : `Bearer ${rawToken}`;
    api.defaults.headers.common["Authorization"] = token;
    console.log("Orders: token synced to axios");
  } else {
    delete api.defaults.headers.common["Authorization"];
    console.warn("Orders: no token in currentUser");
  }

  if (refreshToken) {
    api.defaults.headers.common["x-refresh-token"] = refreshToken;
  } else {
    delete api.defaults.headers.common["x-refresh-token"];
  }
}, [currentUser]);

useEffect(() => {
  const fetchOrders = async () => {
    // Wait until we have a token before attempting the request
    if (!currentUser?.token) return;

    try {
      setLoading(true);
      const res = await api.get("/orders");
      console.log("Fetched orders response:", res.data);
      const fetchedOrders = res.data.orders || res.data;
      setOrders(fetchedOrders);
      setError(null);

      const shortfallOrderIds = (fetchedOrders || [])
        .filter((order) => order.stockShortfall?.length > 0)
        .map((order) => order._id);
      markShortfallOrdersSeen(shortfallOrderIds);
    } catch (err) {
      console.error("Erreur lors du chargement des commandes :", err);
      let errorMessage = "";
      if (err.response?.status === 401) {
        errorMessage = "Non autorisé - Veuillez vous reconnecter.";
      } else if (err.response?.status === 403) {
        errorMessage = "Accès refusé - Vous n'avez pas les droits requis.";
      } else if (err.response?.status === 404) {
        errorMessage = "Aucune commande trouvée";
      } else {
        errorMessage = `Erreur: ${err.response?.data?.message || err.message || "Erreur inconnue"}`;
      }
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  fetchOrders();
}, [currentUser]); // re-runs whenever the user/token changes

// No date filter by default - show every order regardless of when it was
// placed. Previously defaulted to "this week", which silently hid every
// older order with no indication a filter was even active.
const [dateRange, setDateRange] = useState({
  startDate: null,
  endDate: null
});

const handleDateRangeChange = (range) => {
  setDateRange(range);
};

const [search, setSearch] = useState("");
const [filterGroup, setFilterGroup] = useState("Tous");

if (loading) {
  return (
    <div className="Orders">
      <div className="loading-container">
        <div className="loading-spinner-custom"></div>
      </div>
    </div>
  );
}

if (error) {
  return (
    <div className="Orders">
      <div className="error-message-custom">
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="retry-btn"
        >
          Réessayer
        </button>
      </div>
    </div>
  );
}

return (
  <div className="Orders">
    <h1>Commandes</h1>
    <DatePicker onDateRangeChange={handleDateRangeChange} initialRange={{ startDate: null, endDate: null }}/>
    <div className="cards-flex">
    {
      filterCardsData.map((card, index) => (
        <FilterCard
          key={index}
          title={card.title}
          color={card.color}
          onClick={()=>setFilterGroup(card.title)}
        />
      ))
    }
    </div>
    <div className="filter-title">
      <h2>{filterGroup}</h2>
    </div>
    <div className="search-parent">
      <div className="search">
        <input className="search-text" placeholder="Search" onChange={(e) => { setSearch(e.target.value); }} />
        <UilSearch/>
      </div>
    </div>
    <OrdersTable
      orders={orders}
      startDate={dateRange.startDate}
      endDate={dateRange.endDate}
      filterGroup={filterGroup}
      search={search}
    />
  </div>
);
};

export default Orders;
